import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=7953d0fd&scoped=true"
import script from "./uploadBtn.vue?vue&type=script&lang=js"
export * from "./uploadBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadBtn.vue?vue&type=style&index=0&id=7953d0fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953d0fd",
  null
  
)

export default component.exports